<template>
  <div class="coproducer-product-card">
    <template v-if="isGallery">
      <img :src="image" v-if="image" />

      <div
        class="image d-flex align-items-center justify-content-center bg-neutral-076"
        v-else
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="50"
          viewBox="0 0 35 50"
          fill="none"
        >
          <path
            d="M8.07936 15.0873L23.1667 0H0.5V15.0873V22.6667V49.0873L34.5 15.0873H8.07936Z"
            fill="#FCFCFD"
          />
        </svg>
      </div>
    </template>

    <div
      class="list-item"
      :class="isGallery ? 'gallery-display' : 'list-display'"
    >
      <div class="details">
        <img :src="image" alt="product-image" v-if="image" />
        <div
          class="image d-flex align-items-center justify-content-center bg-neutral-076"
          v-else
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="40"
            viewBox="0 0 35 50"
            fill="none"
          >
            <path
              d="M8.07936 15.0873L23.1667 0H0.5V15.0873V22.6667V49.0873L34.5 15.0873H8.07936Z"
              fill="#FCFCFD"
            />
          </svg>
        </div>

        <div class="d-flex flex-column gap-2">
          <div>
            {{ product.name }}
          </div>
          <div class="functional-2 text-neutral-400 product-code">
            {{ product.code }}
          </div>
        </div>
      </div>

      <span
        :class="formatStatusClass(status)"
        class="d-flex align-items-center gap-2 status"
      >
        {{ formatStatus(status) }}
      </span>

      <div class="functional-2 text-neutral-500 product-type">
        {{ formatProductType(product.type_product) }}
      </div>

      <div class="links">
        <bp-button
          size="sm"
          class="fw-4"
          variant="glyph"
          icon="fa-light fa-link"
          label="Links de divulgação"
          @click="openLinks"
        />
      </div>

      <bp-dropdown
        class="dropdown"
        :actions="actions"
        :disabled="status === 'cancelled'"
        :variant="isGallery ? 'filled-2' : 'glyph'"
        @cancel="cancelContract"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isGallery: Boolean,
    product: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: Number,
      default: null
    },
    status: {
      type: String,
      default: ""
    }
  },
  computed: {
    image() {
      return this.product?.picture || null;
    },
    actions() {
      const actions = [
        {
          text: "Cancelar contrato",
          class: "text-negative-600",
          icon: "icon-x",
          dialog: {
            text: "Tem certeza que deseja cancelar o contrato?",
            variant: "negative",
            icon: "fa fa-hexagon-exclamation",
            buttonText: "Cancelar",
            secondaryButtonText: "Confirmar"
          },
          event: "cancel"
        }
      ];

      return actions;
    }
  },
  methods: {
    formatStatus(status) {
      return {
        active: "Ativo",
        cancelled: "Cancelado",
        rejected: "Rejeitado",
        waiting_validation: "Aguardando validação",
        pendent: "Pendente"
      }[status];
    },
    formatStatusClass(status) {
      return {
        active: "active-badge",
        cancelled: "inactive-badge",
        rejected: "inactive-badge",
        waiting_validation: "draft-badge",
        pendent: "draft-badge"
      }[status];
    },
    formatProductType(type_product) {
      return {
        online_course: "Curso Online",
        signature: "Assinatura",
        onsite_event: "Evento presencial"
      }[type_product];
    },

    openLinks() {
      this.$router.push({
        name: "coproducer-product-links",
        params: { id: this.product.id }
      });
    },
    cancelContract() {
      this.loading = true;
      this.$store
        .dispatch("user/updateMyCoproducer", {
          id: this.id,
          status: "cancelled"
        })
        .then(() => {
          this.$emit("refresh");
          this.$message.success("Contrato cancelado com sucesso");
        })
        .catch(() => {
          this.$message.error("Erro ao cancelar contrato");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.coproducer-product-card {
  display: block;
  text-align: left;
  position: relative;
  color: $neutral-700;
  text-decoration: none;

  height: 100%;
  border-radius: 4px;
  border: 1px solid var(--Semantic-Neutral-100, #d7d7d7);
  background: var(--Surface-Cumulative-plus4, rgba(255, 255, 255, 0.16));
  transition: 0.2s all;
  &:hover {
    .dropdown {
      opacity: 1 !important;
    }
  }

  & > img,
  .image {
    width: 100%;
    height: 185px;
    object-fit: cover;
    border-radius: 3px 3px 0 0;
  }

  .list-item {
    display: grid;
    padding: 12px;

    .details {
      order: 1;
      gap: 16px;
      display: flex;
      align-items: center;

      img,
      .image {
        width: 72px;
        height: 72px;
        object-fit: cover;
        border-radius: 4px;
      }
    }
    .status {
      order: 2;
    }
    .product-type {
      order: 3;
    }
    .links {
      order: 4;
    }
    .dropdown {
      order: 5;
    }

    &.gallery-display {
      gap: 4px;
      padding-top: 4px;

      .details {
        img,
        .image,
        .product-code {
          display: none !important;
        }
      }

      .dropdown {
        top: 8px;
        right: 8px;
        position: absolute;
        transition: 0.2s opacity;

        @media screen and (min-width: 992px) {
          &:has(span[style*="display: none"]) {
            opacity: 0;
          }
        }
      }
    }

    &.list-display {
      gap: 16px;
      align-items: center;
      grid-template-columns: 2fr 0.5fr 0.7fr 0.7fr auto;

      .details {
        order: 1;
      }
      .product-type {
        order: 2;
      }
      .links {
        order: 3;
      }
      .status {
        order: 4;
        margin-left: auto;
      }

      @media screen and (max-width: 991px) {
        gap: 8px;
        grid-template-columns: 1fr auto auto;

        .details {
          gap: 8px;
        }
        .product-type,
        .links,
        .created-at {
          display: none;
        }
      }
    }
  }
}
</style>
